import React, { useState } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import {
  Popover,
  List,
  ListItem,
  ListItemText,
  makeStyles,
} from '@material-ui/core';
import { isMobile } from 'react-device-detect';

import ChangeProposalStatus from './ChangeProposalStatus';
import PopUp from '../../Modal/PopUp';
import Snackbar from '../../Snackbar';
import { setProposalSelected, updateProposal, deleteProposal } from '../../../store/actions/ProposalsAction';

import './CardProposal.scss';


const useStyles = makeStyles({
  popper: {
    width: 120,
    margin: '0 24px 0 0',
    boxShadow: isMobile ? 'initial' : '0 2px 5px 0 rgba(0, 0, 0, 0.2)',
    backgroundColor: isMobile ? 'initial' : '#f5f5f5',
  },
  list: {
    width: 120,
    backgroundColor: 'white',
  },
  listItem: {
    '&:hover': {
      backgroundColor: '#f5f5f5',
    },
  },
  listItemText: {
    color: '#484848',
    fontSize: 14,
  },
});

const CardProposal = ({ proposal, proposals, uid, setProposalSelected, updateProposal, deleteProposal, setCreateView, setShowPreview }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const handlePopper = (event, nElem) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  const openPopper = Boolean(anchorEl);
  const date = moment
    .unix(proposal.createdAt && proposal.createdAt._seconds)
    .utc()
    .format('D MMMM YYYY');

    const [openConfirmation, setOpenConfirmation] = useState('');
    const handleCloseConfirmation = () => {
      setOpenConfirmation('');
    }

    const handleEdit = () => {
      handlePopper()
      setProposalSelected(proposal)
      setCreateView(true)
    }
    const confirmDeleteProposal = async () => {
      const newProposal = {...proposal, active: false};
      //console.log('propuesta cambio status', newProposal )
      await deleteProposal(newProposal, proposals, uid)
      handleCloseConfirmation()
      setFeedbackMessage({
        open: true,
        message: 'Se ha eliminado exitosamente',
        variant: 'success',
      });
    }
    const handleDelete = () => {
      handlePopper()
      setOpenConfirmation('delete')
    }

    const changeStatus = async (newStatus) => {
      const newProposal = {...proposal, status: newStatus};
      //console.log('propuesta cambio status', newProposal )
      await updateProposal(newProposal, proposals, uid)
      handleCloseConfirmation()
      setFeedbackMessage({
        open: true,
        message: 'Cambios guardados exitosamente',
        variant: 'success',
      });
    }
    const handleChangeStatus = () => {
      handlePopper()
      setOpenConfirmation('status')
    }

    const [feedbackMessage, setFeedbackMessage] = useState({
      open: false,
      message: '',
      variant: 'success',
    });

    const handleCloseFeedbackMessage = () => {
      setFeedbackMessage({
        open: false,
        message: '',
        variant: 'success',
      });
    };

  return (
    <div className="proposalCard">
      <div className="proposalCard_header" >
        {/* <div className={`proposalCard_badge_${proposal.status}`}>{proposal.status}</div> */}
        <button onClick = {(event) => handlePopper(event)}>
          <img src="/img/icons/menu-options-3.svg" alt="menu opciones" />
        </button>
      </div>
      <div className="proposalCard_content" onClick={() => {
        setShowPreview(true)
        setProposalSelected(proposal)
      }}>
        <p>{proposal && proposal.title}</p>
        <p>{proposal.contact && proposal.contact[0] && proposal.contact[0].fullName}</p>

        <div className="proposalCard_content_date">
          <p>{date}</p>
          <p>{proposal && proposal.source}</p>
        </div>
      </div>

      <Popover
        open={openPopper}
        anchorEl={anchorEl}
        //className={classes.popper}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
      >
        <List
          //className={classes.list}
          component="nav"
          aria-label="secondary mailbox folders"
        >
          <ListItem className={classes.listItem} button>
            <ListItemText
              onClick={() => handleEdit()}
              className={classes.listItemText}
              primary="Editar propuesta económica"
            />
          </ListItem>
          <ListItem className={classes.listItem} button>
            <ListItemText
              onClick={handleDelete}
              className={classes.listItemText}
              primary="Eliminar propuesta económica"
            />
          </ListItem>
          {/* <ListItem className={classes.listItem} button>
            <ListItemText
              onClick={() => handleChangeStatus()}
              className={classes.listItemText}
              primary="Cambiar estatus"
            />
          </ListItem> */}
        </List>
      </Popover>

      <Snackbar
        open={feedbackMessage.open}
        message={feedbackMessage.message}
        variant={feedbackMessage.variant}
        handleClose={handleCloseFeedbackMessage}
        vertical="top"
        horizontal="right"
        snackbarTop="80px"
      />

      <PopUp 
        open={openConfirmation === 'delete'}
        handleClose={handleCloseConfirmation}
        title={'¿Seguro que deseas eliminar esta propuesta económica?'}
        subtitle='Al eliminar una propuesta económica se borrará de tu listado. Los datos eliminados no se pueden recuperar. Para regresar da click en el botón Cancelar.'
        primaryButton={true}
        primaryButtonVariant='primarySolidOutlined'
        primaryButtonText='Sí, Eliminar'
        primaryFunction={confirmDeleteProposal}
        secondaryButton={true}
        secondaryButtonVariant='primary'
      />

      <PopUp 
        open={openConfirmation === 'status'}
        handleClose={handleCloseConfirmation}
        title='Cambiar estatus de la propuesta económica'
        subtitle={['Elige el nuevo estatus para la propuesta económica seleccionada. Recuerda que el buen manejo de los estatus, te ayudará a tener más orden y un mejor control de las propuestas económicas y tus clientes.']}
        content={<ChangeProposalStatus changeStatus={changeStatus} handleClose={handleCloseConfirmation} proposal={proposal} />}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  uid: state.authClient.uid,
  proposals: state.proposalsReducer.proposals,
});

const mapDispatchToProps = (dispatch) => ({
  setProposalSelected: (proposalData) => dispatch(setProposalSelected(proposalData)),
  updateProposal: (proposal, proposalsArray, uid) => dispatch(updateProposal(proposal, proposalsArray, uid)),
  deleteProposal: (proposal, proposalsArray, uid) => dispatch(deleteProposal(proposal, proposalsArray, uid)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CardProposal);
